export default {
  methods: {
    print: function (includes, options) {

      console.log("PRINT REQUEST")
      //console.log(includes)
      //console.log(options)

      //------ catalogo: descrizione catalogo caricato tradotto nella lingua dell’interfaccia
      var catlist = this.$root.dataReferences.getCollection('catalogs')
      var catdesc = catlist.find({
        "id": Number(this.$root.root_index)
      })

      if (catdesc.length > 0) {
        catdesc = catdesc[0].name;
      } else {
        catdesc = "";
      }
      //------>

      //------ linea: descrizione del primo padre di tipo interno line (se esiste) tradotto nella lingua dell’interfaccia, elaborato dal command
      var path = "[]";
      try {
        path = JSON.stringify(this.$root.active_tree_path)
      } catch (err) {
        console.log("caught error on stringify active path: ", err)
      }
      //------>

      var msParams = {
        includes: includes,
        options: options
      }
      this.activeData = this.$store.getters.getActive;


      msParams["fid"] = this.activeData.father.sid;
      msParams["fdes"] = this.activeData.father.des;
      msParams["idUtente"] = this.$Configs.idUtente;
      msParams["catDes"] = catdesc;
      msParams["pathString"] = path;
      try {
        msParams["valuta"] = this.$root.token.valuta;
      } catch (err) {
        console.log(err)
      }
      try {
        msParams["brand"] = this.$root.brandObj ? this.$root.brandObj.cod : (localStorage.getItem('brand') ? JSON.parse(localStorage.getItem('brand')).cod : '')
      } catch (err) {
        console.log(err)
      }

      this.$root
        .microservice({
          serviceType: "pdf",
          role: "generator",
          cmd: "Catalog",
          params: msParams
        }).then((response) => {
          console.log(response)
          if(response.body){
            if(typeof response.body.queue == 'number'){
              if(response.body.queue != 0){
                this.$root.simpleNotification("info", {
                  title: "",
                  message: this.$Jed.firstUpperTranslate("print request of %1$s was accepted, please wait(print queue length: %2$s)", null, {key: null, string: [msParams.fdes, response.body.queue]}, null)
                })
              }else if(response.body.queue == 0){
                this.$root.simpleNotification("info", {
                  title: "",
                  message: this.$Jed.firstUpperTranslate('print request has been sent successfully', null, null, null)
                })
              }
            }else if(response.body.msg){
              this.$root.simpleNotification("warning", {
                title: "",
                message: this.$Jed.firstUpperTranslate(response.body.msg, null, {key: null, string: [msParams.fdes, response.body.limit]}, null)
              })
            }else{
              this.$root.simpleNotification("error", {
                title: "",
                message: this.$Jed.firstUpperTranslate("print request of %1$s was rejected", null, {key: null, string: [msParams.fdes]}, null) + ": "+ response.body.err
              })
            }
          }
        })
        .catch(err => {
          console.log(err);
          var msg = err && err.body && err.body.error ? err.body.error : ''
          eventBus.$emit('alert', {
            message: "Application caught an error <br> <h5>Details: " + "generator.Catalog - " + msg +'</h5>',
            type: "error",
            action: ''
          })
        })
    },
    printOrder: function (idOrdine){
      //il cmd inserisce un'elaborazione "Stampa Ordine" per ogni ordine
      //i parametri vanno passati nel campo Parametri della tabella Elaborazioni, opportunamente separati (magari da un punto e virgola):
      //
      var reg_users = this.$root.dbRegistry.getCollection('users');
      var userRes = reg_users.findOne({'id': Number(this.$Configs.idUtente)});
      
      var msParams = {
        "ordine":[idOrdine], //lista di id ordini
        "cod_lang": this.$Configs.siglaLingua,
        "userId": this.$Configs.idUtente,
        "user": userRes && userRes.user ? userRes.user : '',
        "brand": this.$root.brandObj ? this.$root.brandObj.cod : (localStorage.getItem('brand') ? JSON.parse(localStorage.getItem('brand')).cod : '')
      }
    
      this.$root
        .microservice({
            serviceType: "pdf",
            role: "generator",
            cmd: "Order",
            params: msParams
        }).then((response) => {
            console.log(response)
            if(response){
              this.$root.simpleNotification("info", {
                title: "",
                message: this.$Jed.firstUpperTranslate('print request has been sent successfully', null, null, null)
              })
            }
        }, err=>{
          eventBus.$emit('alert', {
            message: "Application caught an error <br> <h5>Details: " + "generator.Order - " + err +'</h5>',
            type: "error",
            action: ''
          })
        })
        .catch(err => {
            console.log(err);
            var msg = err && err.body && err.body.error ? err.body.error : ''
            eventBus.$emit('alert', {
                message: "Application caught an error <br> <h5>Details: " + "generator.Order - " + msg +'</h5>',
                type: "error",
                action: ''
            })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/print_manager_mixin.js